// External Imports
import { useContext, useEffect, useState, Fragment } from "react";
import { MdAdd, MdAlarm, MdClose } from "react-icons/md";
import { DataContext } from "../../context/data-context";
import { requestAdminAPI } from "../../api/posh-api";
import LoadingSpinner from "./LoadingSpinner";
import { BiCheckDouble } from "react-icons/bi";
import { format } from "date-fns";

// Internal Imports

/** ========================================================================
 * * ReminderMenu Component
 * This component renders a dropdown that shows reminders.
 * ========================================================================== */

export default function ReminderMenu() {
  const { admin, fetchAdmin } = useContext(DataContext);

  const [show, setShow] = useState(false);
  const [add, setAdd] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pendingReminders, setPendingReminders] = useState([]);

  /* ======================  ADD REMINDER ====================== */
  const addReminder = async () => {
    try {
      setLoading(true);
      // Send Request
      await requestAdminAPI("add-reminder", {
        message: document.getElementById("message").value,
        date: document.getElementById("date").value,
      });
      fetchAdmin(() => setLoading(false));
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  /* ======================  MARK AS COMPLETE ====================== */
  const updateReminder = async (id) => {
    try {
      setLoading(true);
      await requestAdminAPI("update-reminder", {
        id,
        completed: true,
      });
      fetchAdmin(() => setLoading(false));
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  // Count pending reminders
  useEffect(() => {
    setPendingReminders(
      admin.reminders?.filter((reminder) => !reminder.completed) || []
    );
  }, [admin]);

  return (
    <Fragment>
      {show && (
        <div
          onClick={() => setShow(false)}
          className="absolute top-0 left-0 w-screen h-screen cursor-pointer bg-stone-900 z-1 opacity-20"
        />
      )}
      <div className="relative">
        <div onClick={() => setShow(!show)} className="relative">
          {pendingReminders.length > 0 && (
            <p className="absolute -left-1 -top-1 text-[8px] rounded-full bg-primary px-1">
              {pendingReminders.length}
            </p>
          )}
          <MdAlarm className="icon" />
        </div>
        {show && (
          <div className="absolute z-10 grid gap-4 p-4 text-xs rounded-lg -right-14 bg-stone-600 top-8 w-60">
            {pendingReminders.length > 0 ? (
              <div className="grid gap-2 max-h-[600px] overflow-scroll no-scrollbar">
                {pendingReminders.map((reminder, idx) => (
                  <div>
                    <div
                      key={idx}
                      className="flex items-center justify-between space-x-1"
                    >
                      <p>
                        {idx + 1}.{" "}
                        {format(new Date(reminder.date), "MM/dd/yyyy")}
                      </p>
                      <BiCheckDouble
                        title="Mark as Completed"
                        className="w-4 h-4 icon"
                        onClick={() => updateReminder(reminder.id)}
                      />
                    </div>
                    <p className="text-left text-stone-400">
                      {reminder.message}
                    </p>
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-stone-200">No pending reminders</p>
            )}
            {add ? (
              <MdClose
                onClick={() => setAdd(false)}
                className="w-full px-auto icon"
              />
            ) : (
              <MdAdd
                onClick={() => setAdd(true)}
                className="w-full px-auto icon"
              />
            )}
            {add && (
              <div className="z-20 grid gap-2 text-stone-200">
                <div className="grid">
                  <p className="font-semibold text-left">Reminder:</p>
                  <input
                    autoComplete="off"
                    type="text"
                    className="text-xs input bg-stone-900"
                    id="message"
                    maxLength={100}
                    required
                  />
                </div>
                <div className="flex items-end justify-between space-x-4">
                  <div className="grid">
                    <p className="font-semibold text-left">Date:</p>
                    <input
                      type="date"
                      className="text-xs input bg-stone-900"
                      id="date"
                      required
                    />
                  </div>
                  {loading ? (
                    <LoadingSpinner classes="w-6 h-6 text-white mx-2 my-1" />
                  ) : (
                    <button onClick={addReminder} className="btn-primary">
                      Add
                    </button>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </Fragment>
  );
}
